function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 50,
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55,66.9863a1.7547,1.7547,0,0,1-1.28-.5615L35.4067,47.1406a1.5258,1.5258,0,0,1,.003-2.081L36.9468,43.45a1.3534,1.3534,0,0,1,.979-.4365,1.288,1.288,0,0,1,.9385.4135L54.1118,59.4834a1.2175,1.2175,0,0,0,1.7764,0L71.1357,43.4272a1.2909,1.2909,0,0,1,.9395-.4135,1.3532,1.3532,0,0,1,.9785.4365l1.5371,1.6089a1.5277,1.5277,0,0,1,.002,2.0825L56.28,66.4248A1.7531,1.7531,0,0,1,55,66.9863Z",
  transform: "translate(-5 -5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.0744,43.5139a.8577.8577,0,0,1,.6175.2818l1.5368,1.6089a1.0339,1.0339,0,0,1,.0018,1.3925L55.9178,66.081a1.2418,1.2418,0,0,1-1.8352,0L35.7692,46.7964a1.0329,1.0329,0,0,1,.0018-1.3911l1.5374-1.61a.8581.8581,0,0,1,.6175-.2818.7932.7932,0,0,1,.576.2576L53.7494,59.8276a1.7171,1.7171,0,0,0,2.5016,0L71.4985,43.7715a.7926.7926,0,0,1,.5759-.2576m0-1a1.7861,1.7861,0,0,0-1.3011.569L55.5259,59.139a.7173.7173,0,0,1-1.0514,0L39.227,43.0829a1.7863,1.7863,0,0,0-1.301-.569,1.85,1.85,0,0,0-1.3407.5911l-1.5374,1.61a2.03,2.03,0,0,0-.0038,2.77L53.3575,66.77a2.2413,2.2413,0,0,0,3.2854,0L74.9557,47.4857a2.0313,2.0313,0,0,0-.0039-2.7718L73.4151,43.105a1.8509,1.8509,0,0,0-1.3407-.5911Z",
  transform: "translate(-5 -5)"
});

var SvgDownArrow = function SvgDownArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "down_arrow",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down_arrow.a27fa10d.svg";
export { ForwardRef as ReactComponent };